import { useBreakpoints as vueUseBreakpoints } from '@vueuse/core';
import config from '../../tailwind.config';

export const useBreakpoints = () => vueUseBreakpoints(config.theme.screens);
